import React, { useState, useRef, useEffect } from "react";
import "./goodiebag.css";
import "./defaultCard.css";
import Gift from "../assets/gift.png";
import GiftFilled from "../assets/gift-filled.png";
import Song from "../assets/song.png";
import SongFilled from "../assets/song-filled.png";
import AudioMessage from "../assets/audio-message.png";
import AudioMessageFilled from "../assets/audio-message-filled.png";
import Video from "../assets/video.png";
import VideoFilled from "../assets/video-filled.png";
import playButton from "../assets/play_button_audio.png";
import pauseButton from "../assets/pause_button_audio.png";
import stopButton from "../assets/stop.png";
// import DefaultGoodie from "../assets/default-goodie.png";
import DefaultGoodie from "../assets/placeholder.png";

import Share from "./Share";
import Loader from "react-loader-spinner";

const GoodieBag = (props) => {
  const {
    recordingLink,
    cardUrl,
    songLink,
    setSongNameVisible,
    videoLink,
    giftLogo,
    giftClaimUrl,
    setIsOpen,
    setShareModelOpen,
  } = props;
  // let videoLink=''
  const [isAllPlaying, setIsAllPlaying] = useState(false);
  const [isSinglePlay, setIsSinglePlay] = useState(false);

  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);
  const [isSongPlaying, setIsSongPlaying] = useState(false);
  const [isGiftVisible, setIsGiftVisible] = useState(false);

  const [lastPlayedMedia, setLastPlayedMedia] = useState(null);
  const [isValidAudio, setIsValidAudio] = useState(true);
  const [isAudioLoading, setIsAudioLoading] = useState(false);

  const audioRef = useRef(null);
  const songRef = useRef(null);
  const videoRef = useRef(null);

  useEffect(() => {
    if (isSongPlaying) {
      setSongNameVisible(true);
    } else {
      setSongNameVisible(false);
    }
  }, [isSongPlaying, setSongNameVisible]);

  useEffect(() => {
    if (videoLink) {
      setIsVideoLoading(true);
    }
    if (videoRef.current && videoLink) {
      videoRef.current.src = videoLink;
    }
  }, [videoLink]);

  useEffect(() => {
    const video = videoRef.current;
    if (video && video === "undefined") {
      // Try to play the video after a delay
      const playVideo = async () => {
        try {
          await video.play();
          console.log("Video is playing");
          // Pause the video after a short delay
          setTimeout(() => {
            video.pause();
            console.log("Video paused");
          }, 500); // Adjust the delay as needed
        } catch (err) {
          console.error("Error trying to play video:", err);
        }
      };

      playVideo();
    }
  }, [videoLink]);

  const [isVideoLoading, setIsVideoLoading] = useState(false);

  const handleVideoLoaded = () => {
    if (videoRef.current) {
      videoRef.current
        ?.play()
        .then(() => {
          videoRef.current?.pause(); // Play and immediately pause to load thumbnail
          setIsVideoLoading(false);
        })
        .catch((error) => {
          console.log("Autoplay prevented:", error); // Handle autoplay restrictions if any
        });
    }
  };

  useEffect(() => {
    const video = videoRef.current;
    const audio = audioRef.current;
    const song = songRef.current;

    const handleVideoEnded = () => {
      console.log("Video ended");
      setIsVideoPlaying(false);

      // Check if audio exists, has a valid source, and play it
      if (audio && audio.src && isValidAudio && !isSinglePlay) {
        audio
          .play()
          .then(() => {
            setIsAudioPlaying(true);
            setLastPlayedMedia("audio");
          })
          .catch((error) => {
            console.error("Audio playback failed:", error);
          });
      } else if (song && song.src && !isSinglePlay) {
        song
          .play()
          .then(() => {
            setIsSongPlaying(true);
            setLastPlayedMedia("song");
          })
          .catch((error) => {
            console.error("Song playback failed:", error);
          });
      } else {
        if (giftClaimUrl) {
          setIsGiftVisible(true);
        }
        setLastPlayedMedia(null);
      }

      if (isSinglePlay) {
        resetAllMedia();
        setIsSinglePlay(false);
      }
    };

    const handleAudioEnded = () => {
      console.log("Audio ended");
      setIsAudioPlaying(false);

      // Check if song exists, has a valid source, and play it
      if (song && song.src && !isSinglePlay) {
        song
          .play()
          .then(() => {
            setIsSongPlaying(true);
            setLastPlayedMedia("song");
          })
          .catch((error) => {
            console.error("Song playback failed:", error);
          });
      } else {
        if (giftClaimUrl) {
          setIsGiftVisible(true);
        }
        setLastPlayedMedia(null);
      }

      if (isSinglePlay) {
        resetAllMedia();
        setIsSinglePlay(false);
      }
    };

    const handleSongEnded = () => {
      setIsSongPlaying(false);

      if (!isSinglePlay) {
        if (giftClaimUrl) {
          setIsGiftVisible(true); // Show the gift when the song ends
        }

        resetAllMedia();
      } else {
        resetAllMedia();
        setIsSinglePlay(false);
      }
    };

    // Attach event listeners
    if (video) video.addEventListener("ended", handleVideoEnded);
    if (audio) audio.addEventListener("ended", handleAudioEnded);
    if (song) song.addEventListener("ended", handleSongEnded);

    // Cleanup event listeners on unmount
    return () => {
      if (video) video.removeEventListener("ended", handleVideoEnded);
      if (audio) audio.removeEventListener("ended", handleAudioEnded);
      if (song) song.removeEventListener("ended", handleSongEnded);
    };
  }, [
    isAllPlaying,
    isSinglePlay,
    isAudioPlaying,
    isSongPlaying,
    isVideoPlaying,
    giftClaimUrl,
    isValidAudio,
  ]);

  useEffect(() => {
    if (isGiftVisible) {
      resetAllMedia(); // Reset when the gift is displayed
    }
  }, [isGiftVisible]);

  const handlePause = () => {
    if (videoRef.current) {
      videoRef.current?.pause();
      setIsAllPlaying(false);
    }
  };

  const handleVideoPlay = () => {
    setIsSinglePlay(true);
    setIsGiftVisible(false);
    setIsAudioPlaying(false);
    setIsSongPlaying(false);
    setLastPlayedMedia("video");

    setTimeout(() => {
      if (videoRef.current && !isVideoPlaying) {
        // resetAllMedia()
        videoRef.current?.play();
        setIsVideoPlaying(true);
      } else if (videoRef.current && isVideoPlaying) {
        videoRef.current?.pause();
        setIsVideoPlaying(false);
      }
    }, 100);
  };

  const handleAudioPlay = () => {
    setIsSinglePlay(true);
    setIsGiftVisible(false);
    setIsVideoPlaying(false);
    setIsSongPlaying(false);
    setLastPlayedMedia("audio");
    // pauseAllMedia()
    if (audioRef.current && !isAudioPlaying) {
      // resetAllMedia()
      audioRef.current?.play();
      setIsAudioPlaying(true);
    } else if (audioRef.current && isAudioPlaying) {
      audioRef.current?.pause();
      setIsAudioPlaying(false);
    }
  };

  const handleSongPlay = () => {
    setIsSinglePlay(true);
    setIsGiftVisible(false);
    setIsAudioPlaying(false);
    setIsVideoPlaying(false);
    setLastPlayedMedia("song");
    if (songRef.current && !isSongPlaying) {
      // resetAllMedia()
      songRef.current?.play();
      setIsSongPlaying(true);
    } else if (songRef.current && isSongPlaying) {
      songRef.current?.pause();
      setIsSongPlaying(false);
    }
  };

  const togglePlayPause_Audio = () => {
    if (isSinglePlay && isVideoPlaying) {
      if (videoRef.current && videoLink) {
        handleVideoPlay();
      }
    } else if (isSinglePlay && isAudioPlaying) {
      handleAudioPlay();
    } else if (isSinglePlay && isSongPlaying) {
      handleSongPlay();
    } else {
      setIsGiftVisible(false);
      if (isAllPlaying) {
        console.log("Pausing media");
        pauseAllMedia();
      } else if (!lastPlayedMedia || isGiftVisible) {
        console.log("Starting media sequence from the beginning");
        resetAllMedia(); // Ensure a clean state before starting
        startMediaSequence(); // Start from the beginning if nothing was playing or gift was visible
      } else {
        console.log("Resuming media from last known state");
        resumeMedia(); // Resume the last played media
      }
    }
    // setIsSinglePlay(false)
  };

  const resumeMedia = () => {
    setIsGiftVisible(false);
    if (lastPlayedMedia) {
      const media = {
        video: { ref: videoRef.current, setState: setIsVideoPlaying },
        audio: { ref: audioRef.current, setState: setIsAudioPlaying },
        song: { ref: songRef.current, setState: setIsSongPlaying },
      };
      const currentMedia = media[lastPlayedMedia];
      if (currentMedia.ref && currentMedia.ref.paused) {
        currentMedia.ref.play();
        currentMedia.setState(true);
        setIsAllPlaying(true);
      }
    }
  };
  const startMediaSequence = () => {
    console.log(
      "in sequence",
      videoRef.current,
      audioRef.current,
      songRef.current
    );

    setTimeout(() => {
      try {
        // Check if any media is available
        const hasVideo = videoRef.current && videoRef.current.src;
        const hasAudio = audioRef.current && audioRef.current.src;
        const hasSong = songRef.current && songRef.current.src;

        if (!hasVideo && !hasAudio && !hasSong) {
          console.log("No media available to play");
          setIsAllPlaying(false);
          return;
        }

        // Play the first available media in priority order
        if (hasVideo) {
          console.log("Starting Video");
          videoRef.current
            .play()
            .then(() => {
              setIsVideoPlaying(true);
              setLastPlayedMedia("video");
              setIsAllPlaying(true);
            })
            .catch((error) => {
              console.error("Video play failed:", error);
              // Fallback to next media if video fails
              if (hasAudio) playAudio();
              else if (hasSong) playSong();
            });
        } else if (hasAudio) {
          playAudio();
        } else if (hasSong) {
          playSong();
        }
      } catch (error) {
        console.error("Media playback error:", error);
        setIsAllPlaying(false);
      }
    }, 100);

    // Helper functions for cleaner code
    const playAudio = () => {
      console.log("Starting Audio");
      audioRef.current
        .play()
        .then(() => {
          setIsAudioPlaying(true);
          setLastPlayedMedia("audio");
          setIsAllPlaying(true);
        })
        .catch((error) => {
          console.error("Audio play failed:", error);
          if (songRef.current && songRef.current.src) playSong();
        });
    };

    const playSong = () => {
      console.log("Starting Song");
      songRef.current
        .play()
        .then(() => {
          setIsSongPlaying(true);
          setLastPlayedMedia("song");
          setIsAllPlaying(true);
        })
        .catch((error) => {
          console.error("Song play failed:", error);
          setIsAllPlaying(false);
        });
    };
  };

  const pauseAllMedia = () => {
    if (videoRef.current && !videoRef.current?.paused) {
      videoRef.current?.pause();
      setIsVideoPlaying(false);
    }
    if (audioRef.current && !audioRef.current?.paused) {
      audioRef.current?.pause();
      setIsAudioPlaying(false);
    }
    if (songRef.current && !songRef.current?.paused) {
      songRef.current?.pause();
      setIsSongPlaying(false);
    }
    setIsAllPlaying(false);
  };

  const resetAllMedia = () => {
    setIsSinglePlay(false);
    console.log("Resetting all media to the beginning");
    if (videoRef.current) {
      videoRef.current?.pause();
      videoRef.current.currentTime = 0;
    }
    if (audioRef.current) {
      audioRef.current?.pause();
      audioRef.current.currentTime = 0;
    }
    if (songRef.current) {
      songRef.current?.pause();
      songRef.current.currentTime = 0;
    }
    setIsVideoPlaying(false);
    setIsAudioPlaying(false);
    setIsSongPlaying(false);
    setIsAllPlaying(false);
    setLastPlayedMedia(null); // Ensure this is reset so the sequence can start fresh
  };

  useEffect(() => {
    if (videoLink && videoRef.current) {
      setIsVideoLoading(true); // Show loader initially

      const videoElement = videoRef.current; // Copy ref to a local variable
      const handleCanPlay = () => {
        setIsVideoLoading(false); // Hide loader once video can play
      };

      videoElement.addEventListener("canplay", handleCanPlay);

      // Trigger video loading to prompt the browser to load the thumbnail
      videoElement.load();

      return () => {
        videoElement.removeEventListener("canplay", handleCanPlay);
      };
    }
  }, [videoLink]);

  useEffect(() => {
    if (recordingLink) {
      setIsAudioLoading(true);
      const testAudio = new Audio(recordingLink);

      testAudio.style.display = "none";
      document.body.appendChild(testAudio);

      const handleCanPlay = () => {
        setIsAudioLoading(false);
        setIsValidAudio(true);
        document.body.removeChild(testAudio);
      };

      const handleError = () => {
        setIsValidAudio(false);
        setIsAudioLoading(false);
        document.body.removeChild(testAudio);
      };

      testAudio.addEventListener("canplaythrough", handleCanPlay);
      testAudio.addEventListener("error", handleError);

      testAudio.load();

      return () => {
        testAudio.removeEventListener("canplaythrough", handleCanPlay);
        testAudio.removeEventListener("error", handleError);
        if (document.body.contains(testAudio)) {
          document.body.removeChild(testAudio);
        }
      };
    } else {
      setIsValidAudio(false);
    }
  }, [recordingLink]);

  useEffect(() => {
    if (!videoLink || !videoRef.current) return;

    const video = videoRef.current;

    const handlePreload = async () => {
      try {
        // Set preload behavior and load explicitly
        video.preload = "auto";
        video.load(); // trigger browser preload

        // Try to buffer silently
        await video.play();
        video.pause();
        console.log("✅ Video preloaded and paused");
      } catch (error) {
        console.warn(
          "⚠️ Preload play attempt failed (likely due to autoplay policy):",
          error
        );
      } finally {
        setIsVideoLoading(false);
      }
    };

    setIsVideoLoading(true);
    handlePreload();

    return () => {
      setIsVideoLoading(false);
    };
  }, [videoLink]);

  console.log("isValidAudio", isValidAudio);

  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [isPageReady, setIsPageReady] = useState(false);

  useEffect(() => {
    if (!videoLink && !recordingLink && !cardUrl) {
      // If nothing to load, set ready immediately
      setIsPageReady(true);
    } else if (!isVideoLoading && !isAudioLoading && isImageLoaded) {
      setIsPageReady(true);
    }
  }, [isVideoLoading, isAudioLoading, isImageLoaded]);
  return (
    <div className="goodie-bag-container">
      <div className="main-container" id="main-container-godie">
        <div className="left-bag-container">
          <div className="left-container-buttons-goodie">
            <div className="left-container-inner-buttons-div-goodie">
              <div>
                {/* {isVideoLoading || isAudioLoading ? (
                  <div className="loaderContainerGoodie">
                    <Loader
                      type="Bars"
                      color="#78438a"
                      height={65}
                      width={65}
                      radius={30}
                    />
                  </div>
                ) : null} */}
                {videoLink && videoLink !== "undefined" ? (
                  <div className="button-container">
                    <div
                      className="video-button"
                      onClick={handleVideoPlay}
                      onEnded={() => {
                        setIsAllPlaying(false);
                      }}
                    >
                      <img
                        src={isVideoPlaying ? VideoFilled : Video}
                        alt="camera-icon"
                        className="video-icon"
                      />
                    </div>
                    <div className="video-text">Video</div>
                  </div>
                ) : null}

                {recordingLink && isValidAudio ? (
                  <div className="button-container">
                    <div className="message-button" onClick={handleAudioPlay}>
                      <img
                        src={isAudioPlaying ? AudioMessageFilled : AudioMessage}
                        alt="mail-icon"
                        className="mail-icon"
                      />
                    </div>
                    <div className="message-text">Message</div>
                  </div>
                ) : null}

                {songLink ? (
                  <div className="button-container">
                    <div className="song-button" onClick={handleSongPlay}>
                      <img
                        src={isSongPlaying ? SongFilled : Song}
                        alt="camera-icon"
                        className="camera-icon-new"
                      />
                    </div>
                    <div className="song-text">Song</div>
                  </div>
                ) : null}

                {giftLogo && giftClaimUrl ? (
                  <div className="button-container">
                    <div
                      className="gift-button"
                      onClick={() => setIsGiftVisible(true)}
                    >
                      <img
                        src={isGiftVisible ? GiftFilled : Gift}
                        alt="mail-icon"
                        className="gift-icon-new"
                      />
                    </div>
                    <div className="gift-text">Gift</div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
        <div className="middle-bag-container">
          {isVideoLoading || isAudioLoading || !isPageReady ? (
            <div className="loaderContainerGoodie">
              <Loader
                type="Bars"
                color="#78438a"
                height={65}
                width={65}
                radius={30}
              />
            </div>
          ) : null}
          <div className="card-heading">
            {isGiftVisible && giftLogo
              ? "Click on the voucher to redeem"
              : isAllPlaying || (!songLink)
                ? "Here's your Jivebird"
                : "Press play for your JiveBird"}
          </div>
          {!isGiftVisible ? (
            <>
              <div
                className="video-container"
                style={{ display: isVideoPlaying ? "block" : "none" }}
              >
                <video
                  // crossOrigin="anonymous"
                  onClick={handlePause}
                  ref={videoRef}
                  src={videoLink}
                  onLoadedData={handleVideoLoaded}
                  className="home-photo-bag"
                  playsInline
                  preload="auto"
                  webkit-playsinline="true"
                  onCanPlay={handleVideoLoaded}
                  style={{
                    objectFit: videoLink?.includes("video_gallery_")
                      ? "contain"
                      : videoLink?.includes("video_")
                        ? "cover"
                        : "contain",
                  }}
                // controls
                >
                  <source src={videoLink} type="video/mp4" />
                  Your browser does not support HTML video.
                </video>
              </div>
              <img
                // src={''}
                src={cardUrl || DefaultGoodie}
                alt="default-goodie"
                onLoad={() => setIsImageLoaded(true)}
                className="home-photo"
                style={{
                  display: isVideoPlaying ? "none" : "block",
                }}
              />
            </>
          ) : (
            <a
              href={giftClaimUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div className="gift-container">
                <img
                  // src={''}
                  src={cardUrl || DefaultGoodie}
                  alt="default-goodie"
                  className="home-photo"
                  style={{
                    display: isVideoPlaying ? "none" : "block",
                    opacity: isGiftVisible ? 0.6 : 1,
                  }}
                />
                {giftLogo ? (
                  <div className="gift-photo-div">
                    <img
                      className="gift-photo"
                      src={giftLogo}
                      alt="gift-logo1"
                    />
                  </div>
                ) : null}
              </div>
            </a>
          )}
          <Share
            setIsOpen={setIsOpen}
            setShareModelOpen={setShareModelOpen}
            pauseAllMedia={pauseAllMedia}
          />
          {songLink ||
            (videoLink && videoLink !== "undefined") ||
            (recordingLink && isValidAudio) ? (
            <>
              <div
                className="semi-circle-audio"
                onClick={togglePlayPause_Audio}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <img
                  src={
                    isVideoPlaying ||
                      isAudioPlaying ||
                      isSongPlaying ||
                      isAllPlaying
                      ? pauseButton
                      : playButton
                  }
                  alt="play/pause button"
                  className="play-button-small"
                  height="100px"
                />
                <span
                  style={{
                    fontSize: "14px",
                    marginTop: "5px",
                    color: "purple",
                    fontWeight: "bold",
                    position: "relative",
                    bottom: "35px",
                    left: "5px",
                  }}
                >
                  Play
                </span>
              </div>

              <div
                className="semi-circle-audio-pause"
                onClick={resetAllMedia}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <img
                  src={stopButton}
                  alt="stop button"
                  className="play-button-small"
                  height="100px"
                />
                <span
                  style={{
                    fontSize: "14px",
                    marginTop: "5px",
                    color: "purple",
                    fontWeight: "bold",
                    position: "relative",
                    bottom: "35px",
                    left: "5px",
                  }}
                >
                  Stop
                </span>
              </div>
            </>
          ) : null}
          <audio
            ref={audioRef}
            src={recordingLink}
            alt="audioRef"
            style={{ display: "none" }}
          />
          <audio
            ref={songRef}
            src={songLink}
            alt="songRef"
            style={{ display: "none" }}
          />
        </div>
        <div className="right-container">
          <div className="right-middle-container">
            {/* Placeholder for any additional content */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GoodieBag;